module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-breadcrumb', {
    staticClass: "app-levelbar",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.levelList), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [(item.redirect === "noredirect" || index == _vm.levelList.length - 1) ? _c('span', {
      staticClass: "no-redirect"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]) : _c('router-link', {
      attrs: {
        "to": item.redirect || item.path
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))])], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28d840c1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Levelbar.vue
// module id = 547
// module chunks = 313